var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.297974,
    width: 72,
    height: 72,
    rx: 6,
    fill: "#EDD8FF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6313 29.6532C49.6323 29.4777 49.5987 29.3038 49.5323 29.1413C49.466 28.9789 49.3682 28.8311 49.2446 28.7065L43.5913 23.0532C43.4667 22.9296 43.3189 22.8319 43.1565 22.7655C42.994 22.6991 42.8201 22.6655 42.6446 22.6665C42.4691 22.6655 42.2952 22.6991 42.1327 22.7655C41.9703 22.8319 41.8225 22.9296 41.698 23.0532L37.9246 26.8265L23.3513 41.3999C23.2277 41.5244 23.1299 41.6722 23.0636 41.8346C22.9972 41.9971 22.9636 42.1711 22.9646 42.3465V47.9999C22.9646 48.3535 23.1051 48.6926 23.3551 48.9427C23.6052 49.1927 23.9443 49.3332 24.298 49.3332H29.9513C30.1379 49.3433 30.3245 49.3142 30.499 49.2475C30.6736 49.1809 30.8322 49.0784 30.9646 48.9465L45.458 34.3732L49.2446 30.6665C49.3663 30.5373 49.4655 30.3886 49.538 30.2265C49.5508 30.1202 49.5508 30.0128 49.538 29.9065C49.5442 29.8445 49.5442 29.7819 49.538 29.7199L49.6313 29.6532ZM29.4046 46.6665H25.6313V42.8932L38.8713 29.6532L42.6446 33.4265L29.4046 46.6665ZM44.5246 31.5465L40.7513 27.7732L42.6446 25.8932L46.4046 29.6532L44.5246 31.5465Z",
    fill: "#A53DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f3caa96cadc2972e62e16cae53f2df81.svg";
export { ForwardRef as ReactComponent };